import Vue from "vue"

Vue.filter("toCurrency", function(value) {
	if (typeof value !== "number") {
		return value
	}
	var formatter = new Intl.NumberFormat("en-US", {
		style: "decimal"
	})
	return formatter.format(value)
})
